import { render } from "./CompKeyboardGuide.vue?vue&type=template&id=fdbc788e"
import script from "./CompKeyboardGuide.vue?vue&type=script&lang=js"
export * from "./CompKeyboardGuide.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__